import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import AutoScrollMedicalStep from "../Components/AutoScrollMedicalStep";
import { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import AllMedicalQuestionsEvaluator from "./AllMedicalQuestionsEvaluator";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredAutoScrollMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  AutoScrollMedicalStep({
    ...props,
    nextStep: Step.scheduling,
    medicalQualificationEvaluator: AllMedicalQuestionsEvaluator,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedAutoScrollMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredAutoScrollMedicalStep>
>({
  Component: ConfiguredAutoScrollMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedAutoScrollMedicalStep;
